import type { DocumentItem } from '@document-explorer/core';
import type { ActionDef, ActionsConfig } from './types.js';

export function resolveActions(actions: ActionsConfig | undefined): ActionDef[] {
  if (!actions) return [];
  if (Array.isArray(actions)) return actions;
  const out: ActionDef[] = [];
  if (actions.view) out.push({ id: 'view', label: 'View', visible: (i) => i.type === 'file' });
  if (actions.download) out.push({ id: 'download', label: 'Download', visible: (i) => i.type === 'file' });
  return out;
}

export function visibleActions(actions: ActionDef[], item: DocumentItem): ActionDef[] {
  return actions.filter((a) => (a.visible ? a.visible(item) : true));
}
